import { WALLETS_API_ENDPOINT } from "../../../constants/constant";
import baseApi from "../../baseApi";
import { ApiResponse, WalletFormType } from "./wallets.type";

export interface UserQueryParams {
  search?: string;
  status?: string;
  userType?: string;
}

export const walletsApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWalletsApiCall: build.query<ApiResponse<WalletFormType>, void>({
      query: () => ({
        url: `${WALLETS_API_ENDPOINT?.GET_WALLETS}`,
        method: "GET",
      }),
    }),

    updateWalletApiCall: build.mutation<ApiResponse, any>({
      query: (walletBody) => ({
        url: `${WALLETS_API_ENDPOINT?.UPDATE_WALLET}`,
        method: "PUT",
        body: walletBody,
      }),
    }),
  }),
});

export const { useGetWalletsApiCallQuery, useUpdateWalletApiCallMutation } =
  walletsApiSlice;

export default walletsApiSlice;
